import {
  LiveTranscriptRole,
  type LiveTranscriptSegment,
} from 'src/components/Assistant/live-transcript/live-transcript.types';

const AGENT_TOKEN = 'Agent';

export interface CallTranscriptSegment extends LiveTranscriptSegment {
  speakerLabel: string;
  offsetSeconds?: number;
}

const parseTimestampToSeconds = (timestamp: string): number | undefined => {
  if (!timestamp) {
    return undefined;
  }

  const parts = timestamp.split(':').map((part) => Number(part.trim()));
  if (parts.length < 2 || parts.length > 3 || parts.some((part) => !Number.isFinite(part))) {
    return undefined;
  }

  return parts.reduce((total, part) => total * 60 + part, 0);
};

export const parseCallTranscriptSegments = (
  transcriptText?: string,
): CallTranscriptSegment[] => {
  if (!transcriptText) {
    return [];
  }

  return transcriptText
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line)
    .map((line, index) => {
      let timestamp = '';
      const start = line.indexOf('[');
      const end = line.indexOf(']', start);
      if (start !== -1 && end !== -1) {
        timestamp = line.slice(start + 1, end).trim();
      }

      const [role, ...text] = line
        .replace(/\[.*?\]/, '')
        .trim()
        .split(':');
      const speakerLabel = role.trim();

      return {
        id: `${index}`,
        role:
          speakerLabel === AGENT_TOKEN ? LiveTranscriptRole.Agent : LiveTranscriptRole.Client,
        speakerLabel,
        timestamp,
        transcriptionText: text.join(':').trim(),
        offsetSeconds: parseTimestampToSeconds(timestamp),
      };
    });
};

export const resolveActiveSegmentIndex = (
  segments: CallTranscriptSegment[],
  currentTimeSeconds: number,
): number => {
  let activeIndex = -1;

  segments.forEach((segment, index) => {
    if (segment.offsetSeconds !== undefined && segment.offsetSeconds <= currentTimeSeconds) {
      activeIndex = index;
    }
  });

  return activeIndex;
};
